export const TEAM_PLAYER_COUNTS = {
  1: '个人',
  2: '混合(2人组)',
  3: '团体(3人组)',
};
